import { Modal, ModalOverlay, ModalCloseButton, ModalBody, useBreakpointValue } from '@chakra-ui/react';
import AdminModalContent from '../layout/AdminModalContent';
import VehicleDetailModal from './VehiclesDetail/VehiclesDetailModal';

const CustomModal = ({ modalState, closeModal }) => {
  const modalWidth = useBreakpointValue({ base: '90%', md: '80%' });

  return (
    <Modal isOpen={modalState.isOpen} onClose={closeModal} closeOnOverlayClick={false}>
      <ModalOverlay />
      <AdminModalContent maxW={modalWidth}>
        <ModalCloseButton />
        <ModalBody>
          {modalState.data?.actionType === 'view' && (
            <VehicleDetailModal
              vehicleData={modalState.data.rowData}
              onClose={closeModal}
            />
          )}
        </ModalBody>
      </AdminModalContent>
    </Modal>
  );
};

export default CustomModal;